(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ruoto-dealcater-unversal"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.ruoto-dealcater');
  if (section) {
    setTimeout(() => {
      section.classList.add('fade-in');
    }, 200);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ruoto-menu-dropdown"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('shopify:section:load', initDropdowns);
document.addEventListener('DOMContentLoaded', initDropdowns);

function initDropdowns() {
  document.querySelectorAll('.custom-menus').forEach(section => {
    const heading = section.querySelector('.dropdown-heading');
    const content = section.querySelector('.dropdown-content');
    if (!heading || !content) return;

    heading.addEventListener('click', () => {
      heading.classList.toggle('active');
      content.classList.toggle('open');
      if (content.classList.contains('open')) {
        setTimeout(() => {
          content.querySelectorAll('.fade-target').forEach(el => el.classList.add('fade-in'));
        }, 150);
      }
    });
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ruoto-season-menus"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', initDropdowns);
document.addEventListener('shopify:section:load', initDropdowns);

function initDropdowns() {
  // 🔸 Klikattavat otsikot (Kausimenut + Kuukaudet)
  document.querySelectorAll('.dropdown-heading').forEach(heading => {
    heading.addEventListener('click', () => {
      let content = heading.nextElementSibling;

      // Jos seuraava elementti ei ole dropdown, etsi seuraava sopiva
      while (
        content &&
        !content.classList.contains('main-dropdown-content') &&
        !content.classList.contains('month-dropdown-content')
      ) {
        content = content.nextElementSibling;
      }

      if (!content) return;

      // 🔄 Vaihda tila
      heading.classList.toggle('active');
      content.classList.toggle('open');

      // ✨ Fade-animaatio kun avataan
      if (content.classList.contains('open')) {
        setTimeout(() => {
          content.querySelectorAll('.fade-target').forEach(el => el.classList.add('fade-in'));
        }, 100);
      }
    });
  });

  // 🔹 Piilotetaan kaikki kuukaudet oletuksena
  const mainDropdown = document.querySelector('.main-dropdown-content');
  if (mainDropdown) {
    mainDropdown.classList.remove('open'); // Suljettuna oletuksena
  }
}

  } catch(e) { console.error(e); }
})();
})();
